import defaultExport from './legos/constants';

export * from './legos/constants';

// Still keeping the constants file here in harmony for backward compatibility with other repos
// Please create any new constants in legos/constants file, not here

export default defaultExport;
